import baseURL from "../baseUrl";
import { timeZone } from "../constants";
import getAccessToken from "../../accessToken";
import { CreateFavoriteParameter } from "./types";

class Favorite {
  async addFavorite(data: CreateFavoriteParameter) {
    const accessToken = getAccessToken();
    const response = await fetch(`${baseURL}/wishlist/create-wishlist`, {
      method: "post",
      headers: {
        timezone: timeZone,
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(data),
    });
    return response.json();
  }
  async deleteFavoriteItem(data: any) {
    const accessToken = getAccessToken();
    const response = await fetch(
      `${baseURL}/wishlist/delete-wishlist-item-id/${data}`,
      {
        method: "delete",
        headers: {
          timezone: timeZone,
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ data }),
      }
    );
    return response.json();
  }
  async deleteFavoriteEstablishment(data: any) {
    const accessToken = getAccessToken();
    const response = await fetch(
      `${baseURL}/wishlist/delete-wishlist-establishment-id/${data}`,
      {
        method: "delete",
        headers: {
          timezone: timeZone,
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ data }),
      }
    );
    return response.json();
  }
  async getFavorites(data: { page?: string }) {
    const accessToken = getAccessToken();
    const page = data.page || "1";

    let url;

    if (data.page) {
      url = `${baseURL}/wishlist/get-wishlist?page=${page}`;
    } else {
      url = `${baseURL}/wishlist/get-wishlist`;
    }
    const response = await fetch(url, {
      method: "get",
      headers: {
        timezone: timeZone,
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.json();
  }
  async getEstablishmentFavorites(data: { page?: string }) {
    const accessToken = getAccessToken();

    const page = data.page || "1";

    let url;

    if (data.page) {
      url = `${baseURL}/wishlist/get-establishment-wishlist?page=${page}`;
    } else {
      url = `${baseURL}/wishlist/get-establishment-wishlist`;
    }
    const response = await fetch(url, {
      method: "get",
      headers: {
        timezone: timeZone,
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.json();
  }
  async getFavoritesByMenu() {
    const accessToken = getAccessToken();
    const response = await fetch(`${baseURL}/favourite/menu`, {
      method: "get",
      headers: {
        timezone: timeZone,
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.json();
  }
}

const instance = new Favorite();
export default instance;
